import { render } from "./UpgradePlan.vue?vue&type=template&id=7c970936&scoped=true&ts=true"
import script from "./UpgradePlan.vue?vue&type=script&lang=ts"
export * from "./UpgradePlan.vue?vue&type=script&lang=ts"

import "./UpgradePlan.vue?vue&type=style&index=0&id=7c970936&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c970936"]])

export default __exports__